export var breakpointXs = '0px';
export var breakpointSm = '600px';
export var breakpointMd = '900px';
export var breakpointLg = '1200px';
export var breakpointXl = '1536px';
export var colorCommonWhite = '#ffffff';
export var colorCommonCoolWhite = '#f2f7ff';
export var colorCommonBlack = '#000000';
export var colorCommonCoolBlack = '#171d26';
export var colorCommonColdBlack = '#001333';
export var colorActionActiveChannel = '0 19 51';
export var colorActionSelectedChannel = '0 19 51';
export var colorActionHoverOpacity = 0.04;
export var colorActionFocusOpacity = 0.12;
export var colorActionActivatedOpacity = 0.54;
export var colorActionSelectedOpacity = 0.08;
export var colorActionDisabledOpacity = 0.38;
export var colorActionDisabledBackgroundOpacity = 0.12;
export var colorActionHover = 'rgba(0,19,51,0.04)';
export var colorActionFocus = 'rgba(0,19,51,0.12)';
export var colorActionActive = 'rgba(0,19,51,0.54)';
export var colorActionSelected = 'rgba(0,19,51,0.08)';
export var colorActionDisabled = 'rgba(0,19,51,0.38)';
export var colorActionDisabledBackground = 'rgba(0,19,51,0.12)';
export var colorPrimary50 = '#f0f5fc';
export var colorPrimary100 = '#cfe0fc';
export var colorPrimary200 = '#accbfc';
export var colorPrimary300 = '#84b1fa';
export var colorPrimary400 = '#5691f0';
export var colorPrimary500 = '#3272d9';
export var colorPrimary600 = '#1d5bbf';
export var colorPrimary700 = '#114599';
export var colorPrimary800 = '#103570';
export var colorPrimary900 = '#15233b';
export var colorPrimaryA100 = '#a9bee0';
export var colorPrimaryA200 = '#839cc4';
export var colorPrimaryA400 = '#5c79a8';
export var colorPrimaryA700 = '#36578c';
export var colorPrimaryLight = '#5691f0';
export var colorPrimaryMain = '#3272d9';
export var colorPrimaryDark = '#1d5bbf';
export var colorPrimaryContrastText = '#ffffff';
export var colorSecondary50 = '#f5f0fa';
export var colorSecondary100 = '#ead9fa';
export var colorSecondary200 = '#dabcf7';
export var colorSecondary300 = '#c79bf2';
export var colorSecondary400 = '#ae74e8';
export var colorSecondary500 = '#9656d6';
export var colorSecondary600 = '#7d3cbd';
export var colorSecondary700 = '#642b9e';
export var colorSecondary800 = '#4b2175';
export var colorSecondary900 = '#371c52';
export var colorSecondaryA100 = '#cab4df';
export var colorSecondaryA200 = '#aa8fc5';
export var colorSecondaryA400 = '#8b6baa';
export var colorSecondaryA700 = '#6b4690';
export var colorSecondaryLight = '#ae74e8';
export var colorSecondaryMain = '#9656d6';
export var colorSecondaryDark = '#7d3cbd';
export var colorSecondaryContrastText = '#ffffff';
export var colorNeutral50 = '#f5f7fa';
export var colorNeutral100 = '#ebeff5';
export var colorNeutral200 = '#dde3ed';
export var colorNeutral300 = '#c8d1e0';
export var colorNeutral400 = '#afbacc';
export var colorNeutral500 = '#8e99ab';
export var colorNeutral600 = '#707a8a';
export var colorNeutral700 = '#58606e';
export var colorNeutral800 = '#434a54';
export var colorNeutral900 = '#333840';
export var colorNeutralA100 = '#c9ced5';
export var colorNeutralA200 = '#a8adb5';
export var colorNeutralA400 = '#868c94';
export var colorNeutralA700 = '#656b74';
export var colorNeutralLight = '#707a8a';
export var colorNeutralMain = '#58606e';
export var colorNeutralDark = '#434a54';
export var colorNeutralContrastText = '#ffffff';
export var colorBackgroundDefault = '#ffffff';
export var colorBackgroundPaper = '#ffffff';
export var colorDivider = 'rgba(0,19,51,0.2)';
export var colorTextPrimaryChannel = '23 29 38';
export var colorTextSecondaryChannel = '23 29 38';
export var colorTextPrimary = 'rgba(23,29,38,0.87)';
export var colorTextSecondary = 'rgba(23,29,38,0.62)';
export var colorTextDisabled = 'rgba(23,29,38,0.38)';
export var colorInfo50 = '#e8f4fa';
export var colorInfo100 = '#bbe5fa';
export var colorInfo200 = '#8dd4f7';
export var colorInfo300 = '#53baed';
export var colorInfo400 = '#229ad6';
export var colorInfo500 = '#0c7bb3';
export var colorInfo600 = '#066391';
export var colorInfo700 = '#064d70';
export var colorInfo800 = '#093952';
export var colorInfo900 = '#0c2938';
export var colorInfoA100 = '#a9bee0';
export var colorInfoA200 = '#839cc4';
export var colorInfoA400 = '#5c79a8';
export var colorInfoA700 = '#36578c';
export var colorInfoLight = '#229ad6';
export var colorInfoMain = '#0c7bb3';
export var colorInfoDark = '#066391';
export var colorInfoContrastText = '#ffffff';
export var colorSuccess50 = '#e1faeb';
export var colorSuccess100 = '#abedc5';
export var colorSuccess200 = '#7ddba3';
export var colorSuccess300 = '#57c282';
export var colorSuccess400 = '#3ba164';
export var colorSuccess500 = '#2a854e';
export var colorSuccess600 = '#20693d';
export var colorSuccess700 = '#1a5230';
export var colorSuccess800 = '#153d25';
export var colorSuccess900 = '#112b1b';
export var colorSuccessA100 = '#8DCAA5';
export var colorSuccessA200 = '#6FA785';
export var colorSuccessA400 = '#518365';
export var colorSuccessA700 = '#336045';
export var colorSuccessLight = '#3ba164';
export var colorSuccessMain = '#2a854e';
export var colorSuccessDark = '#20693d';
export var colorSuccessContrastText = '#ffffff';
export var colorWarning50 = '#fff0e6';
export var colorWarning100 = '#ffe0cc';
export var colorWarning200 = '#ffd1b3';
export var colorWarning300 = '#ffb380';
export var colorWarning400 = '#f78f4a';
export var colorWarning500 = '#f57118';
export var colorWarning600 = '#e6630b';
export var colorWarning700 = '#b34b05';
export var colorWarning800 = '#803a0b';
export var colorWarning900 = '#4d270f';
export var colorWarningA100 = '#e6bfa5';
export var colorWarningA200 = '#cc9e7f';
export var colorWarningA400 = '#b37c58';
export var colorWarningA700 = '#995b32';
export var colorWarningLight = '#e6630b';
export var colorWarningMain = '#b34b05';
export var colorWarningDark = '#803a0b';
export var colorWarningContrastText = '#ffffff';
export var colorError50 = '#faf0f0';
export var colorError100 = '#fad4d4';
export var colorError200 = '#fab6b6';
export var colorError300 = '#fa8e8e';
export var colorError400 = '#f55353';
export var colorError500 = '#de1b1b';
export var colorError600 = '#b80d0d';
export var colorError700 = '#8f0e0e';
export var colorError800 = '#661414';
export var colorError900 = '#451717';
export var colorErrorA100 = '#dcaeae';
export var colorErrorA200 = '#bf8787';
export var colorErrorA400 = '#a16161';
export var colorErrorA700 = '#843a3a';
export var colorErrorLight = '#f55353';
export var colorErrorMain = '#de1b1b';
export var colorErrorDark = '#b80d0d';
export var colorErrorContrastText = '#ffffff';
export var fontFamilyBase = '"Open Sans"'; // Base font family

export var fontFamilySystem = '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'; // Fallback system fonts

export var fontFamilyMonospace = '"SF Mono", "Droid Sans Mono", "Source Code Pro", Monaco, Consolas, "Courier New", Courier, monospace'; // Monospace fonts

export var fontSize3xl = '2.125rem';
export var fontSize2xl = '1.75rem';
export var fontSizeXl = '1.375rem';
export var fontSizeLg = '1.125rem';
export var fontSizeMd = '1rem';
export var fontSizeSm = '0.875rem';
export var fontSizeXs = '0.6875rem';
export var fontWeightLight = 300;
export var fontWeightRegular = 400;
export var fontWeightMedium = 500;
export var fontWeightSemibold = 600;
export var fontWeightBold = 700;
export var lineHeightHeading = 1.25;
export var lineHeightText = 1.5;
export var paletteWhite = '#ffffff';
export var paletteCoolWhite = '#f2f7ff';
export var paletteBlack = '#000000';
export var paletteCoolBlack = '#171d26';
export var paletteColdBlack = '#001333';
export var paletteGrey50 = '#f5f7fa';
export var paletteGrey100 = '#ebeff5';
export var paletteGrey200 = '#dde3ed';
export var paletteGrey300 = '#c8d1e0';
export var paletteGrey400 = '#afbacc';
export var paletteGrey500 = '#8e99ab';
export var paletteGrey600 = '#707a8a';
export var paletteGrey700 = '#58606e';
export var paletteGrey800 = '#434a54';
export var paletteGrey900 = '#333840';
export var paletteGreyA100 = '#c9ced5';
export var paletteGreyA200 = '#a8adb5';
export var paletteGreyA400 = '#868c94';
export var paletteGreyA700 = '#656b74';
export var paletteSuccessGreen50 = '#e1faeb';
export var paletteSuccessGreen100 = '#abedc5';
export var paletteSuccessGreen200 = '#7ddba3';
export var paletteSuccessGreen300 = '#57c282';
export var paletteSuccessGreen400 = '#3ba164';
export var paletteSuccessGreen500 = '#2a854e';
export var paletteSuccessGreen600 = '#20693d';
export var paletteSuccessGreen700 = '#1a5230';
export var paletteSuccessGreen800 = '#153d25';
export var paletteSuccessGreen900 = '#112b1b';
export var paletteSuccessGreenA100 = '#8DCAA5';
export var paletteSuccessGreenA200 = '#6FA785';
export var paletteSuccessGreenA400 = '#518365';
export var paletteSuccessGreenA700 = '#336045';
export var paletteAttentionYellow50 = '#fef9e7';
export var paletteAttentionYellow100 = '#fdf2ce';
export var paletteAttentionYellow200 = '#fbe59d';
export var paletteAttentionYellow300 = '#f9d86c';
export var paletteAttentionYellow400 = '#f7cd3b';
export var paletteAttentionYellow500 = '#f6c41a';
export var paletteAttentionYellow600 = '#dcab09';
export var paletteAttentionYellow700 = '#ab8507';
export var paletteAttentionYellow800 = '#7a610c';
export var paletteAttentionYellow900 = '#4a3c0f';
export var paletteAttentionYellowA100 = '#e3d5a7';
export var paletteAttentionYellowA200 = '#c9b880';
export var paletteAttentionYellowA400 = '#ae9b5a';
export var paletteAttentionYellowA700 = '#947e33';
export var paletteCautionOrange50 = '#fff0e6';
export var paletteCautionOrange100 = '#ffe0cc';
export var paletteCautionOrange200 = '#ffd1b3';
export var paletteCautionOrange300 = '#ffb380';
export var paletteCautionOrange400 = '#f78f4a';
export var paletteCautionOrange500 = '#f57118';
export var paletteCautionOrange600 = '#e6630b';
export var paletteCautionOrange700 = '#b34b05';
export var paletteCautionOrange800 = '#803a0b';
export var paletteCautionOrange900 = '#4d270f';
export var paletteCautionOrangeA100 = '#e6bfa5';
export var paletteCautionOrangeA200 = '#cc9e7f';
export var paletteCautionOrangeA400 = '#b37c58';
export var paletteCautionOrangeA700 = '#995b32';
export var paletteDangerRed50 = '#faf0f0';
export var paletteDangerRed100 = '#fad4d4';
export var paletteDangerRed200 = '#fab6b6';
export var paletteDangerRed300 = '#fa8e8e';
export var paletteDangerRed400 = '#f55353';
export var paletteDangerRed500 = '#de1b1b';
export var paletteDangerRed600 = '#b80d0d';
export var paletteDangerRed700 = '#8f0e0e';
export var paletteDangerRed800 = '#661414';
export var paletteDangerRed900 = '#451717';
export var paletteDangerRedA100 = '#dcaeae';
export var paletteDangerRedA200 = '#bf8787';
export var paletteDangerRedA400 = '#a16161';
export var paletteDangerRedA700 = '#843a3a';
export var paletteMineralBlue50 = '#f0f5fc';
export var paletteMineralBlue100 = '#cfe0fc';
export var paletteMineralBlue200 = '#accbfc';
export var paletteMineralBlue300 = '#84b1fa';
export var paletteMineralBlue400 = '#5691f0';
export var paletteMineralBlue500 = '#3272d9';
export var paletteMineralBlue600 = '#1d5bbf';
export var paletteMineralBlue700 = '#114599';
export var paletteMineralBlue800 = '#103570';
export var paletteMineralBlue900 = '#15233b';
export var paletteMineralBlueA100 = '#a9bee0';
export var paletteMineralBlueA200 = '#839cc4';
export var paletteMineralBlueA400 = '#5c79a8';
export var paletteMineralBlueA700 = '#36578c';
export var paletteAquaGreen50 = '#e4f7f6';
export var paletteAquaGreen100 = '#a8ede9';
export var paletteAquaGreen200 = '#6cd9d2';
export var paletteAquaGreen300 = '#45bfb7';
export var paletteAquaGreen400 = '#28a199';
export var paletteAquaGreen500 = '#17827b';
export var paletteAquaGreen600 = '#116963';
export var paletteAquaGreen700 = '#0d524d';
export var paletteAquaGreen800 = '#0b3d3a';
export var paletteAquaGreen900 = '#092b29';
export var paletteAquaGreenA100 = '#89cac6';
export var paletteAquaGreenA200 = '#69a7a3';
export var paletteAquaGreenA400 = '#4a8380';
export var paletteAquaGreenA700 = '#2a605d';
export var paletteDusk50 = '#f4f2f7';
export var paletteDusk100 = '#e3dcf7';
export var paletteDusk200 = '#cec2f0';
export var paletteDusk300 = '#b5a6e3';
export var paletteDusk400 = '#9886cf';
export var paletteDusk500 = '#7a68b3';
export var paletteDusk600 = '#645396';
export var paletteDusk700 = '#4f4178';
export var paletteDusk800 = '#3a3154';
export var paletteDusk900 = '#282436';
export var paletteDuskA100 = '#c1bad6';
export var paletteDuskA200 = '#9f98b6';
export var paletteDuskA400 = '#7e7595';
export var paletteDuskA700 = '#5c5375';
export var paletteIndigo50 = '#f2f2fc';
export var paletteIndigo100 = '#dcdcfc';
export var paletteIndigo200 = '#c2c2fc';
export var paletteIndigo300 = '#a7a7fa';
export var paletteIndigo400 = '#8585f2';
export var paletteIndigo500 = '#6767e6';
export var paletteIndigo600 = '#4d4dd1';
export var paletteIndigo700 = '#3737b3';
export var paletteIndigo800 = '#28288a';
export var paletteIndigo900 = '#202057';
export var paletteIndigoA100 = '#b8b8e5';
export var paletteIndigoA200 = '#9494ce';
export var paletteIndigoA400 = '#7070b8';
export var paletteIndigoA700 = '#4c4ca1';
export var paletteFuchsia50 = '#faf0f4';
export var paletteFuchsia100 = '#fad4e4';
export var paletteFuchsia200 = '#fab4d1';
export var paletteFuchsia300 = '#f78bb8';
export var paletteFuchsia400 = '#ed5393';
export var paletteFuchsia500 = '#d6246e';
export var paletteFuchsia600 = '#b01355';
export var paletteFuchsia700 = '#8a1244';
export var paletteFuchsia800 = '#611535';
export var paletteFuchsia900 = '#421527';
export var paletteFuchsiaA100 = '#dbaec1';
export var paletteFuchsiaA200 = '#bd889e';
export var paletteFuchsiaA400 = '#9e617b';
export var paletteFuchsiaA700 = '#803b58';
export var paletteLavender50 = '#f5f0fa';
export var paletteLavender100 = '#ead9fa';
export var paletteLavender200 = '#dabcf7';
export var paletteLavender300 = '#c79bf2';
export var paletteLavender400 = '#ae74e8';
export var paletteLavender500 = '#9656d6';
export var paletteLavender600 = '#7d3cbd';
export var paletteLavender700 = '#642b9e';
export var paletteLavender800 = '#4b2175';
export var paletteLavender900 = '#371c52';
export var paletteLavenderA100 = '#cab4df';
export var paletteLavenderA200 = '#aa8fc5';
export var paletteLavenderA400 = '#8b6baa';
export var paletteLavenderA700 = '#6b4690';
export var paletteSkyBlue50 = '#e8f4fa';
export var paletteSkyBlue100 = '#bbe5fa';
export var paletteSkyBlue200 = '#8dd4f7';
export var paletteSkyBlue300 = '#53baed';
export var paletteSkyBlue400 = '#229ad6';
export var paletteSkyBlue500 = '#0c7bb3';
export var paletteSkyBlue600 = '#066391';
export var paletteSkyBlue700 = '#064d70';
export var paletteSkyBlue800 = '#093952';
export var paletteSkyBlue900 = '#0c2938';
export var paletteSkyBlueA100 = '#a9bee0';
export var paletteSkyBlueA200 = '#839cc4';
export var paletteSkyBlueA400 = '#5c79a8';
export var paletteSkyBlueA700 = '#36578c';
export var paletteSlate50 = '#edf4f7';
export var paletteSlate100 = '#cbe3f5';
export var paletteSlate200 = '#a7ceeb';
export var paletteSlate300 = '#84b7db';
export var paletteSlate400 = '#5e95bd';
export var paletteSlate500 = '#48799c';
export var paletteSlate600 = '#376180';
export var paletteSlate700 = '#2d4d63';
export var paletteSlate800 = '#243947';
export var paletteSlate900 = '#1d2830';
export var paletteSlateA100 = '#aac1d2';
export var paletteSlateA200 = '#889faf';
export var paletteSlateA400 = '#677d8d';
export var paletteSlateA700 = '#455b6a';
export var paletteGreen50 = '#e9f8e3';
export var paletteGreen100 = '#d2f0c7';
export var paletteGreen200 = '#9fdc8a';
export var paletteGreen300 = '#6bc84c';
export var paletteGreen400 = '#55b336';
export var paletteGreen500 = '#3f9e20';
export var paletteGreen600 = '#348a18';
export var paletteGreen700 = '#29750f';
export var paletteGreen800 = '#215e0d';
export var paletteGreen900 = '#19470a';
export var paletteGreenA100 = '#afd3a2';
export var paletteGreenA200 = '#8bb67d';
export var paletteGreenA400 = '#689857';
export var paletteGreenA700 = '#447b32';
export var paletteMagenta50 = '#faeff8';
export var paletteMagenta100 = '#f5dff1';
export var paletteMagenta200 = '#efbce7';
export var paletteMagenta300 = '#e899dc';
export var paletteMagenta400 = '#dc7dce';
export var paletteMagenta500 = '#cf61bf';
export var paletteMagenta600 = '#bb4daa';
export var paletteMagenta700 = '#a63895';
export var paletteMagenta800 = '#882d7a';
export var paletteMagenta900 = '#69215e';
export var paletteMagentaA100 = '#dfbbd9';
export var paletteMagentaA200 = '#c998c1';
export var paletteMagentaA400 = '#b474aa';
export var paletteMagentaA700 = '#9e5192';
export var paletteNavy50 = '#f0f2fa';
export var paletteNavy100 = '#e1e5f5';
export var paletteNavy200 = '#c5ccee';
export var paletteNavy300 = '#a8b2e6';
export var paletteNavy400 = '#8b97d8';
export var paletteNavy500 = '#6d7cc9';
export var paletteNavy600 = '#5c6bb9';
export var paletteNavy700 = '#4a5aa8';
export var paletteNavy800 = '#3d4b90';
export var paletteNavy900 = '#303c78';
export var paletteNavyA100 = '#c0c6e1';
export var paletteNavyA200 = '#9fa7cd';
export var paletteNavyA400 = '#7f89b8';
export var paletteNavyA700 = '#5e6aa4';
export var paletteOrange50 = '#fef1d9';
export var paletteOrange100 = '#fce2b3';
export var paletteOrange200 = '#facb7a';
export var paletteOrange300 = '#f7b440';
export var paletteOrange400 = '#e29c22';
export var paletteOrange500 = '#cc8304';
export var paletteOrange600 = '#ac6f05';
export var paletteOrange700 = '#8c5b06';
export var paletteOrange800 = '#734d0a';
export var paletteOrange900 = '#593e0e';
export var paletteOrangeA100 = '#e1c491';
export var paletteOrangeA200 = '#c5a66f';
export var paletteOrangeA400 = '#aa894e';
export var paletteOrangeA700 = '#8e6b2c';
export var palettePink50 = '#feeff3';
export var palettePink100 = '#fcdee6';
export var palettePink200 = '#fabbcc';
export var palettePink300 = '#f797b1';
export var palettePink400 = '#ef7a99';
export var palettePink500 = '#e65c81';
export var palettePink600 = '#d24268';
export var palettePink700 = '#bd284f';
export var palettePink800 = '#9c1e3f';
export var palettePink900 = '#7a142f';
export var palettePinkA100 = '#e9b8c5';
export var palettePinkA200 = '#d691a3';
export var palettePinkA400 = '#c26b82';
export var palettePinkA700 = '#af4460';
export var palettePurple50 = '#f7f0fb';
export var palettePurple100 = '#efe1f7';
export var palettePurple200 = '#dec3f0';
export var palettePurple300 = '#cca5e8';
export var palettePurple400 = '#bd8ede';
export var palettePurple500 = '#ad77d4';
export var palettePurple600 = '#9a62c2';
export var palettePurple700 = '#864cb0';
export var palettePurple800 = '#6f3d93';
export var palettePurple900 = '#572d75';
export var palettePurpleA100 = '#d5c0e3';
export var palettePurpleA200 = '#bc9fcf';
export var palettePurpleA400 = '#a27fbb';
export var palettePurpleA700 = '#895ea7';
export var paletteRed50 = '#fdefee';
export var paletteRed100 = '#fadfdc';
export var paletteRed200 = '#f8bdb6';
export var paletteRed300 = '#f59a90';
export var paletteRed400 = '#ee7c6f';
export var paletteRed500 = '#e65d4e';
export var paletteRed600 = '#d04536';
export var paletteRed700 = '#ba2d1e';
export var paletteRed800 = '#992316';
export var paletteRed900 = '#78180d';
export var paletteRedA100 = '#e7b9b4';
export var paletteRedA200 = '#d3948d';
export var paletteRedA400 = '#c06e65';
export var paletteRedA700 = '#ac493e';
export var paletteSteelBlue50 = '#eaf5fa';
export var paletteSteelBlue100 = '#d5ebf5';
export var paletteSteelBlue200 = '#abd5e7';
export var paletteSteelBlue300 = '#80bed9';
export var paletteSteelBlue400 = '#61a3c0';
export var paletteSteelBlue500 = '#4288a6';
export var paletteSteelBlue600 = '#3a7994';
export var paletteSteelBlue700 = '#316a82';
export var paletteSteelBlue800 = '#29576a';
export var paletteSteelBlue900 = '#214352';
export var paletteSteelBlueA100 = '#b3cdd9';
export var paletteSteelBlueA200 = '#90b0bd';
export var paletteSteelBlueA400 = '#6e92a2';
export var paletteSteelBlueA700 = '#4b7586';
export var paletteTaupe50 = '#f6f3ed';
export var paletteTaupe100 = '#ede6da';
export var paletteTaupe200 = '#dbd2c3';
export var paletteTaupe300 = '#c9beab';
export var paletteTaupe400 = '#b0a593';
export var paletteTaupe500 = '#968c7b';
export var paletteTaupe600 = '#82796b';
export var paletteTaupe700 = '#6e665b';
export var paletteTaupe800 = '#58534c';
export var paletteTaupe900 = '#42403c';
export var paletteTaupeA100 = '#cfc9be';
export var paletteTaupeA200 = '#b1aba1';
export var paletteTaupeA400 = '#948e85';
export var paletteTaupeA700 = '#767068';
export var paletteTealGreen50 = '#edf9f8';
export var paletteTealGreen100 = '#daf2f0';
export var paletteTealGreen200 = '#8fddd6';
export var paletteTealGreen300 = '#44c7bc';
export var paletteTealGreen400 = '#2eaba1';
export var paletteTealGreen500 = '#188f85';
export var paletteTealGreen600 = '#138178';
export var paletteTealGreen700 = '#0d736a';
export var paletteTealGreen800 = '#0b5f57';
export var paletteTealGreen900 = '#084a44';
export var paletteTealGreenA100 = '#b1d5d1';
export var paletteTealGreenA200 = '#87b7b3';
export var paletteTealGreenA400 = '#5e9a94';
export var paletteTealGreenA700 = '#347c76';
export var paletteYellow50 = '#f6f5c2';
export var paletteYellow100 = '#edea85';
export var paletteYellow200 = '#ddd74d';
export var paletteYellow300 = '#ccc314';
export var paletteYellow400 = '#b5ad0a';
export var paletteYellow500 = '#9e9600';
export var paletteYellow600 = '#867f00';
export var paletteYellow700 = '#6e6800';
export var paletteYellow800 = '#5a5504';
export var paletteYellow900 = '#454208';
export var paletteYellowA100 = '#d0cc6b';
export var paletteYellowA200 = '#b2ae51';
export var paletteYellowA400 = '#959138';
export var paletteYellowA700 = '#77731e';
export var shadow0 = 'none';
export var shadow1 = '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)';
export var shadow2 = '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';
export var shadow3 = '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)';
export var shadow4 = '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)';
export var shadow5 = '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)';
export var shadow6 = '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)';
export var shadow7 = '0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12)';
export var shadow8 = '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)';
export var shadow9 = '0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14), 0px 3px 16px 2px rgba(0,0,0,0.12)';
export var shadow10 = '0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)';
export var shadow11 = '0px 6px 7px -4px rgba(0,0,0,0.2), 0px 11px 15px 1px rgba(0,0,0,0.14), 0px 4px 20px 3px rgba(0,0,0,0.12)';
export var shadow12 = '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)';
export var shadow13 = '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 13px 19px 2px rgba(0,0,0,0.14), 0px 5px 24px 4px rgba(0,0,0,0.12)';
export var shadow14 = '0px 7px 9px -4px rgba(0,0,0,0.2), 0px 14px 21px 2px rgba(0,0,0,0.14), 0px 5px 26px 4px rgba(0,0,0,0.12)';
export var shadow15 = '0px 8px 9px -5px rgba(0,0,0,0.2), 0px 15px 22px 2px rgba(0,0,0,0.14), 0px 6px 28px 5px rgba(0,0,0,0.12)';
export var shadow16 = '0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12)';
export var shadow17 = '0px 8px 11px -5px rgba(0,0,0,0.2), 0px 17px 26px 2px rgba(0,0,0,0.14), 0px 6px 32px 5px rgba(0,0,0,0.12)';
export var shadow18 = '0px 9px 11px -5px rgba(0,0,0,0.2), 0px 18px 28px 2px rgba(0,0,0,0.14), 0px 7px 34px 6px rgba(0,0,0,0.12)';
export var shadow19 = '0px 9px 12px -6px rgba(0,0,0,0.2), 0px 19px 29px 2px rgba(0,0,0,0.14), 0px 7px 36px 6px rgba(0,0,0,0.12)';
export var shadow20 = '0px 10px 13px -6px rgba(0,0,0,0.2), 0px 20px 31px 3px rgba(0,0,0,0.14), 0px 8px 38px 7px rgba(0,0,0,0.12)';
export var shadow21 = '0px 10px 13px -6px rgba(0,0,0,0.2), 0px 21px 33px 3px rgba(0,0,0,0.14), 0px 8px 40px 7px rgba(0,0,0,0.12)';
export var shadow22 = '0px 10px 14px -6px rgba(0,0,0,0.2), 0px 22px 35px 3px rgba(0,0,0,0.14), 0px 8px 42px 7px rgba(0,0,0,0.12)';
export var shadow23 = '0px 11px 14px -7px rgba(0,0,0,0.2), 0px 23px 36px 3px rgba(0,0,0,0.14), 0px 9px 44px 8px rgba(0,0,0,0.12)';
export var shadow24 = '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)';
export var shapeBorderRadius = '3px';
export var spacing = 8; // Use multiples/divisions of value

export var typographyFontFamily = '"Open Sans", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'; // Default font family

export var typographyFontSize = '14px'; // Default font size

export var typographyFontWeightLight = 300;
export var typographyFontWeightRegular = 400;
export var typographyFontWeightMedium = 600;
export var typographyFontWeightBold = 700;
export var typographyHtmlFontSize = '16px'; // Font size applied to HTML element

export var typographyH1FontSize = '2.125rem';
export var typographyH1FontWeight = 700;
export var typographyH1LetterSpacing = '-0.24px';
export var typographyH1LineHeight = 1.25;
export var typographyH2FontSize = '1.75rem';
export var typographyH2FontWeight = 700;
export var typographyH2LetterSpacing = '-0.2px';
export var typographyH2LineHeight = 1.25;
export var typographyH3FontSize = '1.375rem';
export var typographyH3FontWeight = 700;
export var typographyH3LetterSpacing = '-0.1px';
export var typographyH3LineHeight = 1.25;
export var typographyH4FontSize = '1.125rem';
export var typographyH4FontWeight = 700;
export var typographyH4LetterSpacing = '-0.1px';
export var typographyH4LineHeight = 1.25;
export var typographyH5FontSize = '0.875rem';
export var typographyH5FontWeight = 600;
export var typographyH5LineHeight = 1.5;
export var typographyH6FontSize = '0.875rem';
export var typographyH6FontWeight = 400;
export var typographyH6LineHeight = 1.5;
export var typographyBody1FontSize = '1rem';
export var typographyBody1FontWeight = 400;
export var typographyBody1LineHeight = 1.5;
export var typographyBody2FontSize = '0.875rem';
export var typographyBody2FontWeight = 400;
export var typographyBody2LineHeight = 1.5;
export var typographyButtonFontSize = '0.875rem';
export var typographyButtonFontWeight = 600;
export var typographyButtonLineHeight = 1.42875;
export var typographyCaptionFontSize = '0.6875rem';
export var typographyCaptionFontWeight = 400;
export var typographyCaptionLineHeight = 1.5;
export var zIndexMobileStepper = 1000;
export var zIndexFab = 1050;
export var zIndexSpeedDial = 1050;
export var zIndexAppBar = 1100;
export var zIndexDrawer = 1200;
export var zIndexModal = 1300;
export var zIndexSnackbar = 1400;
export var zIndexTooltip = 1500;